import { FormControl, Validators } from '@angular/forms';

import * as RegexPattern from '@teem/constants/regex-patterns';
import { Client } from '@teem/models/client';

export class ClientForm {
	uuid = new FormControl();
	first_name = new FormControl('', [Validators.required,Validators.maxLength(99),Validators.minLength(2)]);
	last_name = new FormControl('',[Validators.maxLength(99),Validators.minLength(2)]);
	email = new FormControl('', [Validators.email]);
	phone = new FormControl('', [Validators.required,Validators.maxLength(10)]);
	dial_code = new FormControl();
	business_name = new FormControl();
	tax_reg_number = new FormControl();
	country_id = new FormControl('', [Validators.required]);
	website = new FormControl('', [Validators.pattern(RegexPattern.url)]);
	address = new FormControl();
	date_of_birth = new FormControl();

	buyer_first_name = new FormControl(null);
	buyer_last_name = new FormControl(null);
	buyer_address = new FormControl(null);
	buyer_vat_number = new FormControl(null);
	buyer_cr_number = new FormControl(null);

	constructor(client: Client) {
		if (client) {

			if (client.uuid) {
				this.uuid.setValue(client.uuid)
			}

			this.first_name.setValue(client.first_name);
			this.last_name.setValue(client.last_name);
			this.email.setValue(client.email);
			this.dial_code.setValue(client.dial_code ? '+'+client.dial_code : '');
			this.phone.setValue(client.phone);
			this.business_name.setValue(client.business_name);
			this.tax_reg_number.setValue(client.tax_reg_number);
			this.country_id.setValue(client.country_id);
			this.website.setValue(client.website);
			this.address.setValue(client.address);
			this.date_of_birth.setValue(client.date_of_birth);
			
			this.buyer_first_name.setValue(client.buyer_first_name);
			this.buyer_last_name.setValue(client.buyer_last_name);
			this.buyer_address.setValue(client.buyer_address);
			this.buyer_vat_number.setValue(client.buyer_vat_number);
			this.buyer_cr_number.setValue(client.buyer_cr_number);

		}
	}
}
